import { Fill, Stroke, Style, Text } from "ol/style";
import CircleStyle from "ol/style/Circle";

export const getWeatherStationStyle = feature => {
  return new Style({
    image: new CircleStyle({
      radius: 6,
      fill: new Fill({ color: '#318bff' }),
      stroke: new Stroke({ color: '#ffffff', width: 2 })
    }),
    text: new Text({
      text: feature.get('name'),
      fill: new Fill({ color: '#ffffff' }),
      backgroundFill: new Fill({ color: 'rgba(0,0,0,0.6)' }),
      backgroundStroke: new Stroke({ color: '#000000' }),
      padding: [2, 4, 2, 4],
      offsetY: -20
    })
  });
};